import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';

export default function CancelPage() {
  return (
    <Layout
      title="Payment cancelled"
      description="You cancelled your payment. Your form data has been saved."
    >
      <div style={{ marginTop: '1.5rem' }}>
        <Link
          to="/waiting"
          style={{
            display: 'inline-block',
            padding: '0.6rem 1.4rem',
            background: 'var(--color-accent)',
            color: '#fff',
            borderRadius: 'var(--radius)',
            fontFamily: 'sans-serif',
            fontSize: '0.9rem',
          }}
        >
          Try again
        </Link>
      </div>
    </Layout>
  );
}
